__turbopack_context__.v({
  "container": "TextFieldMatch-module__KeWegq__container",
  "inline": "TextFieldMatch-module__KeWegq__inline",
  "matchedText": "TextFieldMatch-module__KeWegq__matchedText",
  "withHighlights": "TextFieldMatch-module__KeWegq__withHighlights",
});
